import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'sdpost-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: [
    '../../../../../shared/ui/src/lib/styles/_shared/error-page.scss',
    './page-not-found.component.scss'
  ]
})
export class PageNotFoundComponent implements OnInit {
  constructor(private readonly titleService: Title) {
    this.titleService.setTitle('Sorry, we could not find the page you are looking for');
  }

  ngOnInit() {}
}
